import {useLogger, useSharedState} from '@deliveryhero/vendor-web-core';
import {jwtDecode} from 'jwt-decode';
import {useEffect, useState} from 'react';
import {AUTH_STATE, TokenInfo, AuthStateSlice} from '../interfaces/AuthState';

// returns pesmissions map, entry example: "cv4z;FP_SG" => ['order_processing']
export const usePermissions = (): Map<string, string[]> => {
  const accessToken = useSharedState<string | undefined>(
    (state) => (state[AUTH_STATE] as AuthStateSlice).accessToken,
  );
  const logger = useLogger();
  const [permissionsMap, setPermissionsMap] = useState(new Map<string, string[]>());

  useEffect(() => {
    let currentPermissionsMap = new Map<string, string[]>();
    if (accessToken !== undefined) {
      try {
        const decodedAccessToken: TokenInfo = jwtDecode<TokenInfo>(accessToken);
        const permissionsArray: string[] = decodedAccessToken.metadata.permissions ?? [];

        currentPermissionsMap = permissionsArray.reduce((map, entry) => {
          const [platformRestaurantId, globalEntityId, ...permissions] = entry.split(';');
          return map.set(`${platformRestaurantId};${globalEntityId}`, permissions);
        }, new Map<string, string[]>());
      } catch (error) {
        logger.error('usePermissions: accessToken decode error: ', error, {});
      }
    } else {
      logger.warning('usePermissions: no accessToken data', {}, {accessToken});
    }
    setPermissionsMap(currentPermissionsMap);
  }, [accessToken, logger]);

  return permissionsMap;
};
